import { Action } from '@ngrx/store';

export enum ActionTypes {
    ADD = '[Loading] Add',
    REMOVE = '[Loading] Remove',
    CLEAR = 'Loading Clear',
}

export class Add implements Action {
    readonly type = ActionTypes.ADD;

    constructor(public payload: string) {}
}

export class Remove implements Action {
    readonly type = ActionTypes.REMOVE;

    constructor(public payload: string) {}
}

export class Clear implements Action {
    readonly type = ActionTypes.CLEAR;
}

export type Actions = Add | Remove | Clear;
